import { type JSX, useMemo } from 'react';

import {
  getMasterProjects,
  getSubProjects,
  useGetProjectQuery,
  useGetProjectsQuery,
  useSelectedProjectId,
  useSyncSelectedProjectFromRoute,
} from 'features/projects';

import { Sidebar, SidebarContent } from '@/components/ui/sidebar';

import AppSidebarFooter from './AppSidebarFooter';
import MasterProjectNav from './MasterProjectNav';
import SidebarBrand from './SidebarBrand';
import SubProjectsNav from './SubProjectsNav';

const AppSidebar = (): JSX.Element => {
  const selectedId = useSelectedProjectId();
  const { data: projects = [] } = useGetProjectsQuery();
  const { data: selectedProject } = useGetProjectQuery(selectedId ?? 0, { skip: selectedId === null });

  const selectedMasterProject = useMemo(
    () => getMasterProjects(projects).find((p) => p.id === selectedId) ?? null,
    [projects, selectedId]
  );

  const selectedSubProjects = useMemo(
    () => getSubProjects(projects, selectedMasterProject?.id ?? null),
    [projects, selectedMasterProject]
  );

  const projectBasePath = selectedId !== null ? `/project/${selectedId}` : '/project';

  useSyncSelectedProjectFromRoute();

  return (
    <Sidebar collapsible="icon">
      <SidebarBrand />
      <SidebarContent>
        {selectedId !== null && (
          <MasterProjectNav
            projectBasePath={projectBasePath}
            isFinancialEntity={selectedProject?.isFinancialEntity ?? false}
          />
        )}
        {selectedId !== null && (
          <SubProjectsNav selectedSubProjects={selectedSubProjects} projectBasePath={projectBasePath} />
        )}
      </SidebarContent>
      <AppSidebarFooter />
    </Sidebar>
  );
};

export default AppSidebar;
